import React from "react";
import { NOTIFICATION_DELAY } from "../timing";

export default class FadeOutNotification extends React.Component {
  show() {
    this.notification && $(this.notification).finish().show().delay(NOTIFICATION_DELAY).fadeOut();
  }

  render() {
    return (
      <div ref={(el) => this.notification = el} style={{ display: 'none', position: 'fixed', bottom: this.props.bottom || 15, left: this.props.left, right: this.props.left == null ? 15 : undefined }}>
        <div className={'alert alert-' + (this.props.theme || 'success') + ' d-inline-block px-5'}>
          {this.props.children}
        </div>
      </div>
    );
  }
}
